
import { useStore } from "vuex";
import { defineComponent } from "vue";
import Drugs from "./Drugs.vue";
import SelectSkill from "./SelectSkill.vue";
import LevelUp from "./LevelUp.vue";
import GenericPanel from "../shared/GenericPanel.vue";
import GenericSubPanel from "../shared/GenericSubPanel.vue";

export default defineComponent({
  name: "Actions",
  components: {
    Drugs,
    SelectSkill,
    LevelUp,
    GenericPanel,
    GenericSubPanel
},
  setup() {
    const store = useStore();
    return {
      state: store.state,
      CharStats: store.state.build.CharStats,
    };
  },
});
